import { render } from "./Watchlist.vue?vue&type=template&id=567af75c&scoped=true"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"

import "./Watchlist.vue?vue&type=style&index=0&id=567af75c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\GameToGo\\Desktop\\ecommerce-movie7-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567af75c"]])

export default __exports__